import template from './Loader.html.njk';
import type { LoaderProps } from './Loader';

const LoaderComponent = (props: LoaderProps) => template.render(props);

export default LoaderComponent;
